import { workloadScenarioSettingsLoaded } from 'owa-scenario-settings';
import { mutator } from 'satcheljs';
import { getStore } from '../store/store';
import { updateTop } from 'owa-navigation-stack';

export const workloadScenarioSettingsLoadedMutator = mutator(
    workloadScenarioSettingsLoaded,
    actionMessage => {
        const { settings } = actionMessage;
        if (settings.timePanelSelectedView) {
            updateTop(settings.timePanelSelectedView, getStore().panelViewStack.stack);
        }
    }
);
